import { jsx as n } from "react/jsx-runtime";
import { c as p } from "react/compiler-runtime";
import { Menu as s } from "@mui/material";
import { forwardRef as f } from "react";
const a = f((m, i) => {
  const o = p(7);
  let r, e;
  o[0] !== m ? ({
    children: r,
    ...e
  } = m, o[0] = m, o[1] = r, o[2] = e) : (r = o[1], e = o[2]);
  let t;
  return o[3] !== r || o[4] !== e || o[5] !== i ? (t = /* @__PURE__ */ n(s, { ref: i, ...e, children: r }), o[3] = r, o[4] = e, o[5] = i, o[6] = t) : t = o[6], t;
});
export {
  a as Menu
};
